import React from 'react';
import './CtNumericInpunt.css';
import { InputNumber } from 'antd';
import PropTypes from 'prop-types';

class CtNumericInpunt extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
  };
  onChange = (value) => {
    const reg = /^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/;
    if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
      this.props.onChange(value);
    }
  };

  // '.' at the end or only '-' in the input box.

  render() {
    return (
      <InputNumber
        min={0}
        max={10}
        step={0.01}
        {...this.props}
        onChange={this.onChange}
        placeholder="Input a number"
        maxLength="25"
      />
    );
  }
}

export default CtNumericInpunt;



// WEBPACK FOOTER //
// ./src/components/ct-numeric-inpunt/CtNumericInpunt.js